import { VIRTUAL_SCROLL_STRATEGY } from "@angular/cdk/scrolling";
import { AfterViewChecked, Component, Inject, Renderer2 } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { CustomVirtualScroll } from "@classes/CustomVritualScoll";
import { PlaysAPIService } from '@api/services/games/plays-api.service';
import { Router } from '@angular/router';
import { FireBase } from "@classes/fireBase";
import { logEvent } from "firebase/analytics";
import { ToastrService } from "ngx-toastr";
import { HeaderService } from "@api/services/header.service";

@Component({
    selector: 'app-bottomSheetAbono',
    templateUrl: './bottomSheetAbono.component.html',
    styleUrls: ['./bottomSheetAbono.component.scss'],
    providers: [{ provide: VIRTUAL_SCROLL_STRATEGY, useClass: CustomVirtualScroll }],
    standalone: false
})
export class bottomSheetAbonoComponent extends FireBase implements AfterViewChecked {

	random = false;
	public play: any;
	public abono: any;
	public texto: string = '';
	public modoGrupo: boolean;
	public aviso: string = '';
	public guinda: string = '';

	constructor(
		private bottomSheetAbono: MatBottomSheetRef<bottomSheetAbonoComponent>,
		private playsAPIService: PlaysAPIService,
		private router: Router,
		@Inject(MAT_BOTTOM_SHEET_DATA) public data: { play: any },
		private renderer: Renderer2,
		private toastrService: ToastrService,
		private headerService: HeaderService
	) {
		super();
		this.play = this.data.play;
	}

	ngAfterViewChecked() {
		this.headerService.modeGrupoCoolOb.subscribe(res => {
			this.modoGrupo = res;
		})
		
		if (this.play) {
			let day = new Date(this.play.dateSorteo);
			if (this.play.idGame == 7 && day.getDay() != 4) {
				this.texto = 'Estas jugadas se renovarán automáticamente cada lunes con el mismo número si contamos con stock disponible y se cobrarán de tu tarjeta o del saldo en tu cuenta de usuario. Además, también te guardaremos el número para Navidad y El Niño. Mucha suerte.';
				this.aviso = 'Importante: la renovación del abono no está asegurada. Su continuidad dependerá de la disponibilidad de los décimos correspondientes.';
			}
			else if (this.play.idGame == 7) {
				this.texto = 'Estas jugadas se renovarán automáticamente cada lunes con el mismo número si contamos con stock disponible y se cobrarán de tu tarjeta o del saldo en tu cuenta de usuario.'
				this.aviso = 'Importante: la renovación del abono no está asegurada. Su continuidad dependerá de la disponibilidad de los décimos correspondientes.';
			}
			else if ([6,8].includes(this.play.idGame)) {
				this.texto = 'La suscripción consiste en que cada lunes se comprará tu jugada de forma automática para toda la semana con el mismo número si contamos con stock disponible y se cobrarán de tu tarjeta o del saldo en tu cuenta de usuario.';
				this.aviso = 'Importante: la renovación del abono no está asegurada. Su continuidad dependerá de la disponibilidad de los décimos correspondientes.';
			} else {
				this.texto = 'La suscripción consiste en que cada día de sorteo a las 8:00 se comprara tu jugada de forma automática con las características que tú elijas y se cobrarán de tu tarjeta o del saldo en tu cuenta de usuario. Mucha suerte';
			}

			if (this.play.guinda) {
				this.guinda = 'Tu elección de laguinda se respetará en las jugadas abonadas.';
			}
		}
	}

	suscribirse() {
		let grupo_id = this.modoGrupo ? this.play.cliente_id : null;
		this.playsAPIService.abonoPlay(this.play.id, this.random, grupo_id).subscribe(res => {
			if (res) {
				logEvent(this.analytics, "subscribe");
				this.play.abono = res;
				this.abono = this.play.abono != null;
				this.bottomSheetAbono.dismiss(true);
			} else {
				this.toastrService.error('Ha ocurrido un error');
			}
		});
	}

	dismiss() {
		this.bottomSheetAbono.dismiss(false);
	}
}
